export const SET_USER = "reference/set_user";
export const CLEAR_USER = "reference/clear_user";

export const SET_PROFILE = "reference/set_profile";
export const CLEAR_PROFILE = "reference/clear_profile";

export const RESET_REFERENCES = "list/reset_references";
